import { useState } from "react";
import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { type ClassroomReportRow } from "./types";
import { ReportDateSearch } from "./ReportDateSearch";

export function SearchBar({
  onResult,
  onClassroom,
}: {
  onResult: (r: ClassroomReportRow) => void;
  onClassroom: (id: number) => void;
}) {
  const [classroomIdList, setClassroomIdList] = useState("");

  return (
    <div className="rounded-xl border bg-card shadow-sm px-5 py-4 flex flex-col gap-4">
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wide">
        Look up report
      </p>

      <div className="flex flex-col gap-2">
        <ReportDateSearch onResult={onResult} />
      </div>

      <div className="border-t" />

      <div className="flex flex-wrap items-end gap-2">
        <div className="flex flex-col gap-1 w-28">
          <label className="text-xs text-muted-foreground">Classroom ID</label>
          <Input
            placeholder="e.g. 284"
            value={classroomIdList}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value))
                setClassroomIdList(e.target.value);
            }}
            onKeyDown={(e) =>
              e.key === "Enter" &&
              classroomIdList &&
              onClassroom(Number(classroomIdList))
            }
          />
        </div>
        <Button
          onClick={() =>
            classroomIdList && onClassroom(Number(classroomIdList))
          }
          disabled={!classroomIdList}
          variant="outline"
          className="gap-2"
        >
          <Search className="size-4" />
          Show all reports
        </Button>
      </div>
    </div>
  );
}
